import React from 'react';
import { CardContainer, Card, CardTitle, CardDescription, Icon, Title } from './CardSlider.styles';

const CardComponent = ({ title, description, icon, isCardCenter }) => {
  const isImageIcon = typeof icon === 'string';

  return (
    <Card id={'CardComponent'} isCenter={isCardCenter}>
      <CardTitle isCenter={isCardCenter}>
        {icon && (
          <Icon isCenter={isCardCenter}>
            {isImageIcon ? <img src={icon} alt="Icon" /> : icon}
          </Icon>
        )}
        <Title isCenter={isCardCenter}>{title}</Title>
      </CardTitle>
      <CardDescription isCenter={isCardCenter}>{description}</CardDescription>
    </Card>
  );
};

const CardSlider = ({ cards, isCenter = false }) => {
  return (
    <CardContainer>
      {cards.map((card, index) => (
        <CardComponent key={index} {...card} isCardCenter={isCenter} />
      ))}
    </CardContainer>
  );
};

export default CardSlider;
